import { Component, OnInit } from '@angular/core';
import { FormService } from '../form.service';

declare let $:any;

@Component({
  selector: 'hc-support-categories',
  templateUrl: './support-categories.component.html'
})
export class SupportCategoriesComponent implements OnInit {

  constructor(
    private form : FormService
  ) { }

  ngOnInit() {
  }

  setCategory(name) {
    this.form.selectedCategory = name;
    setTimeout(() => {
      $('html, body').animate({
       scrollTop: $("#scrollTo").offset().top
       }, 2000);
    }, 200);
  }

}



// WEBPACK FOOTER //
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/app/support-categories/support-categories.component.ts